import React from 'react';
import {
    TableWrapper,
    TableTitle,
    StyledTableContainer,
    StyledTable,
    StyledTableHead,
    StyledTableBody,
    StyledTableRow,
    StyledTableHeaderCell,
    StyledTableCell,
} from './style';

const PopulationMoveRouteTable = ({ title, params, data, items }) => {

    //if (!data || !title) return null;
    return (
        <TableWrapper>
            <TableTitle>지역내 : {title}</TableTitle>
            <StyledTableContainer style={{ whiteSpace: 'nowrap'}}>
                <StyledTable>
                    <StyledTableHead>
                        <StyledTableRow>
                            <StyledTableHeaderCell>순위</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">{params?.direction === "in" ? "전입 지역" : " 전출 지역 "}</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">{params?.type?.includes("pop") ? "인구" : params?.type ? "가구" : ""} (점유율)</StyledTableHeaderCell>
                        </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                        {items.map((row, index) => (
                            <StyledTableRow key={row.rank}>
                                <StyledTableCell fontWeight="medium">{row.rank}</StyledTableCell>
                                <StyledTableCell align="right">{params?.direction === "in" ? row?.inNm : row?.outNm}</StyledTableCell>
                                <StyledTableCell align="right">{params?.direction === "in" ? row?.inCnt : row?.outCnt}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </StyledTableBody>
                </StyledTable>
            </StyledTableContainer>
        </TableWrapper>
    );
};

export default PopulationMoveRouteTable;
